// extracted by mini-css-extract-plugin
export default {"wrapper":"NC-z","viewport":"OC-z","container":"PC-z","slide":"QC-z"};